const API = "https://unitedmigrants.com/api";

export default API;
